<script setup lang="ts">
import { RouterView } from 'vue-router'
import ScrollToTop from './components/ScrollToTop.vue'
import AppHeader from './components/AppHeader.vue'

// APP_NAME is the single source of truth for the brand — import it here when
// per-route <title> updates (router.afterEach) are implemented.
</script>

<template>
  <!--
    NOTE: The <title> in index.html is APP_NAME. For per-route <title> updates
    (outside INC-007 scope), use vue-router's afterEach or a watcher on $route.
  -->
  <!-- overflow-x-clip contains full-bleed breakouts (e.g. CampaignView's
       w-screen row) without becoming a scroll container, so position:sticky
       children still resolve against the window. -->
  <div class="min-h-screen overflow-x-clip bg-background text-fg-primary">
    <AppHeader />

    <main class="min-h-[calc(100vh-4rem)]">
      <RouterView />
    </main>
    <ScrollToTop />
  </div>
</template>
